import { render, staticRenderFns } from "./OrderSynchronization.vue?vue&type=template&id=6c6e5d3c&scoped=true"
import script from "./OrderSynchronization.vue?vue&type=script&lang=js"
export * from "./OrderSynchronization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6e5d3c",
  null
  
)

export default component.exports